<!-- 数据调用配置表 -->
<template>
  <div class="tableShow">
    <Table
      ref="table"
      :loadObj="{}"
      :dict="[]"
      :option="{}"
      :colObj="{
        opId: '20006',
        col: [],
      }"
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablec";
export default {
  components: {
    Table,
  },
  data() {
    return {
         
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  activated() {},
};
</script>

<style></style>